import React, { FC } from 'react';
import { Slider } from '@mui/material';

interface Props {
  value: number;
  onChange: (e: any) => void;
  min: number;
  max: number;
  getAriaValueText: (value: any) => void;
  getAriaLabel: (value: any) => void;
  marks: any[];
  disabled: boolean;
  topOrBottom: string;
}

const CustomSlider: FC<Props> = ({
  value,
  onChange,
  min,
  max,
  getAriaValueText,
  getAriaLabel,
  marks,
  disabled,
  topOrBottom
}: any) => {
  const bottomMarks = marks.map(
    (item: { value: number; label: string }, index: number) => {
      if (index === 1) return { value: -item.value, label: item.label };
      else return item;
    }
  );

  bottomMarks.reverse();

  const handleRangeChange = (event: Event, newValue: any) => {
    const [leftValue, rightValue] = newValue;

    const absLeftValue = Math.abs(leftValue);
    const absRightValue = Math.abs(rightValue);

    if (topOrBottom === 'top' && absLeftValue !== min) {
      onChange(absLeftValue);

      return;
    }
    if (topOrBottom === 'bottom' && absRightValue !== min) {
      onChange(absRightValue);

      return;
    }
    if (topOrBottom === 'top') {
      onChange(absRightValue);

      return;
    }
    if (topOrBottom === 'bottom') {
      onChange(absLeftValue);

      return;
    }
  };

  return (
    <Slider
      size='medium'
      valueLabelDisplay='auto'
      aria-labelledby='slider'
      onChange={handleRangeChange}
      value={topOrBottom === 'top' ? [min, value] : [-value, max]}
      min={topOrBottom === 'top' || topOrBottom === '' ? min : -max}
      max={topOrBottom === 'top' || topOrBottom === '' ? max : 0}
      sx={{
        '	.MuiSlider-mark': {
          display: 'none'
        },
        '& .MuiSlider-thumb:last-child': {
          display: topOrBottom === 'bottom' ? 'none' : 'flex'
        },
        '& .MuiSlider-thumb': {
          display: topOrBottom === 'top' || topOrBottom === '' ? 'none' : 'flex'
        }
      }}
      getAriaValueText={getAriaValueText}
      getAriaLabel={getAriaLabel}
      marks={topOrBottom === 'top' || topOrBottom === '' ? marks : bottomMarks}
      disabled={disabled}
    />
  );
};

export default CustomSlider;
